<template>
    <label class="gmf-radio-btn" :class="{
        'gmf-radio-btn--button': isButton,
    }">
        <input type="radio" :checked="modelValue === value" @change="$emit('update:modelValue', value)" :disabled="disabled" />
        <span v-if="label" v-text="label" />
    </label>
</template>

<style>
.gmf-radio-btn {
    padding: var(--gmf-p-4) var(--gmf-p-5);
    cursor: pointer;
    display: flex;
    gap: var(--gmf-p-3);
    align-items: center;
}

.gmf-context .gmf-radio-btn input[type="radio"] {
    -webkit-appearance: none !important;
    appearance: none !important;
    background: var(--gmf-col-gray) !important;
    margin: 0 !important;

    height: 18px;
    width: 18px;

    padding: 1px !important;
    border: none !important;
    border-radius: 99px !important;
    border: 0px solid var(--gmf-col-gray) !important;

    transition: all 0.1s ease-out;

    display: initial;

    cursor: pointer;
}

.gmf-context .gmf-radio-btn input[type="radio"]:checked {
    border: 5px solid var(--gmf-highlight-col) !important;
    background: var(--gmf-col-white) !important;
}

.gmf-context .gmf-radio-btn input[type="radio"]:checked~span {
    color: var(--gmf-col-black);
}

.gmf-context .gmf-radio-btn--button {
    background: var(--gmf-input-bg);
    border-radius: var(--gmf-rounding);
}
</style>

<script>
export default {
    props: ['value', 'modelValue', 'label', 'disabled', 'isButton'],
};
</script>
